import { useFormikContext } from 'formik';
import termsData from '../../assets/json/onlending.json';
import { X } from 'lucide-react';
import { ContentItem, renderContent } from 'utils/utils';

const TermsAndConditionsModal = ({
  setIsOpen,
}: {
  setIsOpen: (isOpen: boolean) => void;
}) => {
  const { setFieldValue, values } = useFormikContext<{
    termsAndCondition: boolean;
  }>();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full max-h-[650px] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h1 className="text-2xl font-bold text-gray-900">
            Terms and Conditions
          </h1>
          <button
            onClick={() => {
              setIsOpen(false);
            }}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6">
          <ol className="space-y-6">
            {termsData.content.map((section, index) => (
              <li
                key={index}
                className="space-y-3"
              >
                {section.content.map((item, i) =>
                  renderContent(item as ContentItem, i)
                )}
              </li>
            ))}
          </ol>
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-gray-200">
          <button
            onClick={() => {
              if (!values.termsAndCondition) {
                setFieldValue('termsAndCondition', true);
              }
              setIsOpen(false);
            }}
            className="w-full bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
          >
            I Agree
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionsModal;
